export enum AffiliateFeatureEnum {
  OTPAuthOnly = 1,
  UseTelegraDashboard = 2,
  MarketingEmails = 3,
}
